// To parse this data:
//
//   import { Convert, MemberTemplate } from "./file";
//
//   const memberTemplate = Convert.toMemberTemplate(json);

export interface MemberTemplate {
	activationDate?: number[];
	isStaff?: boolean;
	officeId?: number;
	officeOptions?: OfficeOption[];
	staffOptions?: StaffOption[];
	savingProductOptions?: SavingProductOption[];
	genderOptions?: Option[];
	clientTypeOptions?: Option[];
	clientClassificationOptions?: Option[];
	clientNonPersonConstitutionOptions?: any[];
	clientNonPersonMainBusinessLineOptions?: any[];
	clientLegalFormOptions?: ClientLegalFormOption[];
	familyMemberOptions?: FamilyMemberOptions;
	address?: Address[];
	isAddressEnabled?: boolean;
}

export interface Address {
	countryIdOptions?: Option[];
	stateProvinceIdOptions?: Option[];
	addressTypeIdOptions?: Option[];
}

export interface Option {
	id?: number;
	name?: string;
	position?: number;
	description?: string;
	active?: boolean;
	mandatory?: boolean;
}

export interface ClientLegalFormOption {
	id?: number;
	code?: string;
	value?: string;
}

export interface FamilyMemberOptions {
	relationshipIdOptions?: Option[];
	genderIdOptions?: Option[];
	maritalStatusIdOptions?: Option[];
	professionIdOptions?: Option[];
}

export interface OfficeOption {
	id?: number;
	name?: string;
	nameDecorated?: string;
}

export interface SavingProductOption {
	id?: number;
	name?: string;
	withdrawalFeeForTransfers?: boolean;
	allowOverdraft?: boolean;
	enforceMinRequiredBalance?: boolean;
	withHoldTax?: boolean;
}

export interface StaffOption {
	id?: number;
	firstname?: string;
	lastname?: string;
	displayName?: string;
	mobileNo?: string;
	officeId?: number;
	officeName?: string;
	isLoanOfficer?: boolean;
	isActive?: boolean;
	joiningDate?: number[];
}

// Converts JSON strings to/from your types
export class ConvertMemberTemplate {
	public static toMemberTemplate(json: string): MemberTemplate {
		return JSON.parse(JSON.stringify(json));
	}

	public static memberTemplateToJson(value: MemberTemplate): string {
		return JSON.stringify(value);
	}
}
